import FroalaEditor from "froala-editor";
import { i18n } from "@/i18n/index";
import { ro, enUS } from "date-fns/locale";
import { format } from "date-fns";
import { formatOptions } from "./DateFormats";

Object.assign(FroalaEditor.POPUP_TEMPLATES, {
    "fromatDatePlugin.popup": "[_TITLE_][_OPTIONS_][_BUTTONS_]"
});

Object.assign(FroalaEditor.DEFAULTS, {
    popupButtons: ["setLanguage", "popupCancel", "popupApply"]
});

FroalaEditor.PLUGINS.fromatDatePlugin = function fromatDatePlugin(editor) {
    let varType;
    let dateformat;
    let thousandsSeparator = ",";
    let decimalSeparator = ".";
    let language;
    let popupTemplate;
    let el;
    const coords = {
        top: 0,
        left: 0,
        offset: 0
    };
    const err = {
        thousand: false,
        decimal: false
    };

    function createOptions() {
        const formats = formatOptions.map(({ type, value }) => {
            let tempLang;
            if (language && language === "en") {
                tempLang = enUS;
            } else if (language && language === "ro") {
                tempLang = ro;
            } else if (localStorage.getItem("language") === "en") {
                tempLang = enUS;
            } else if (localStorage.getItem("language") === "ro") {
                tempLang = ro;
            }
            return {
                type,
                value,
                label: format(new Date(), value, { locale: tempLang })
            };
        });
        return formats.reduce((acumulator, curentItem, index) => {
            if (curentItem.type !== varType) {
                return acumulator;
            }
            acumulator += `<input type="radio" name="date-format" id="opt${index}" ${
                curentItem.value === dateformat ? "checked" : ""
            }><label for="opt${index}" class="fr-command " data-cmd="setFormat" data-param1="${curentItem.value}">${curentItem.label}</label>`;
            return acumulator;
        }, "");
    }
    function createNumbersOptions() {
        return `
                <input type="radio" name="number-format" id="opt0" ${dateformat === "none" ? "checked" : ""}>
                <label for="opt0" data-cmd="setFormat" data-param1="none" class="fr-command ">None</label>
                <input type="radio" name="number-format" id="opt1" ${dateformat === "custom" ? "checked" : ""}>
                <label  for="opt1" data-cmd="setFormat" data-param1="custom" class="fr-command ">Custom</label>
                <div class="fr-link-insert-layer fr-layer fr-active" id="fr-custom-format">
                    <div class="fr-input-line">
                        <input type="text" name="thousands" class="fr-number${thousandsSeparator !== "" ? " fr-not-empty" : ""} input-style" value="${
    thousandsSeparator
}" placeholder="Thousands separator" autocomplete="off" id="fr-thousands-separator"/>
                    </div>
                    <div id="thousands-error" class="error-field"></div>
                    <div class="fr-input-line">
                        <input  type="text" name="decimal" class="fr-number${decimalSeparator !== "" ? " fr-not-empty" : ""} input-style " value="${
    decimalSeparator
}" placeholder="Decimal separator" autocomplete="off" id="fr-decimal-separator"/>
                    </div>
                    <div id="decimal-error" class="error-field"></div>
                </div>
                `;
    }

    function createPopupTemplate() {
        let popupButtons = "";
        const dateTitle = i18n.t("froala.customDateTitle");
        const datePopupTitle = `<div class="popup-title"> ${dateTitle}  </div>`;
        const nrTitle = i18n.t("froala.customNrTitle");
        const nrPopupTitle = `<div class="popup-title"> ${nrTitle}  </div>`;
        if (editor.opts.popupButtons.length > 1) {
            if ((varType === "integer" || varType === "decimal" || varType === "string") && editor.opts.popupButtons[0] === "setLanguage") {
                editor.opts.popupButtons.shift();
            } else if ((varType !== "integer" || varType !== "decimal" || varType !== "string") && editor.opts.popupButtons.length === 2) {
                editor.opts.popupButtons.unshift("setLanguage");
            }
            popupButtons = `<div class="fr-buttons">${editor.button.buildList(editor.opts.popupButtons)}</div>`;
        }

        const template = {
            title: datePopupTitle,
            options: `<div class="fr-dropdown-list options-container role="option">${createOptions(varType)}</div>`,
            buttons: popupButtons
        };
        const numbersTemplate = {
            title: nrPopupTitle,
            options: `<div class="fr-dropdown-list options-container-number role="option">${createNumbersOptions(varType)}</div>`,
            buttons: popupButtons
        };
        return varType === "integer" || varType === "decimal" || varType === "string" ? numbersTemplate : template;
    }

    function initPopup() {
        const popup = editor.popups.get("fromatDatePlugin.popup");
        if (popup) {
            popup.remove();
        }
        popupTemplate = createPopupTemplate();
        editor.popups.create("fromatDatePlugin.popup", popupTemplate);

        editor.popups.get("fromatDatePlugin.popup").attr("id", "format-date");
    }

    function setPopupPosition(elem) {
        const wHeight = document.documentElement.clientHeight;
        const target = elem || el;
        coords.left = editor.$(target).offset().left;
        coords.top = editor.$(target).offset().top + 10;
        if (coords.top > wHeight - 370) {
            coords.top -= 390;
            if (coords.top < 0) {
                coords.top = 10;
            }
        }
        coords.offset = 0;
    }

    function setInputsVisibility(newFormat) {
        if (varType === "decimal" || varType === "integer" || varType === "string") {
            const popup = editor.popups.get("fromatDatePlugin.popup");
            const inputsContainer = popup.find("#fr-custom-format");
            if (newFormat === "none") {
                inputsContainer.addClass("hidden");
            } else {
                inputsContainer.removeClass("hidden");
            }
        }
    }

    function showPopup() {
        el = editor.selection.element();
        editor.selection.clear();
        if (!editor.$(el).hasClass("fr-tribute")) {
            el = el.parentElement;
        }
        const targetedTypes = {
            date: true,
            datetime: true,
            time: true,
            decimal: true,
            integer: true,
            string: true
        };
        varType = editor.$(el).attr("data-type");
        dateformat = editor.$(el).attr("data-format");
        language = editor.$(el).attr("data-lang") || "en";
        if (varType === "decimal" || varType === "integer" || varType === "string") {
            if (dateformat === "custom") {
                thousandsSeparator = editor.$(el).attr("data-thousands");
                decimalSeparator = editor.$(el).attr("data-decimal");
            } else {
                dateformat = "none";
                thousandsSeparator = "";
                decimalSeparator = "";
            }
        }
        if (!targetedTypes[varType]) {
            return;
        }
        initPopup();
        setPopupPosition(el);

        editor.popups.show("fromatDatePlugin.popup", coords.left, coords.top, coords.offset);
        setInputsVisibility(dateformat);
        const popup = editor.popups.get("fromatDatePlugin.popup");
        const numberInputs = popup.find('input.fr-number[type="text"]');
        const apply = popup.find('button[data-cmd="popupApply"]');

        numberInputs.on("paste keyup cut", function checkValue() {
            const illegalChars = ["<", ">"];
            const { value, name } = this; // the "this" context is the HTML input object
            for (let i = 0; i < illegalChars.length; i++) {
                const char = illegalChars[i];
                if (name === "decimal" && value === "") {
                    popup.find("#decimal-error").html(editor.vueInstance.$t("froala.decimalError"));
                    err[name] = true;
                    apply.addClass("fr-disabled");
                    break;
                } else if (value.indexOf(char) > -1) {
                    popup.find(`#${name}-error`).html(editor.vueInstance.$t("froala.separatorError", { char }));
                    err[name] = true;
                    apply.addClass("fr-disabled");
                    break;
                } else {
                    popup.find(`#${name}-error`).html("");
                    err[name] = false;
                    if (!err.thousand && !err.decimal) {
                        apply.removeClass("fr-disabled");
                    }
                }
            }
        });
    }

    function hidePopup() {
        editor.popups.hide("fromatDatePlugin.popup");
    }

    function applyFormat() {
        if (varType === "decimal" || varType === "integer" || varType === "string") {
            if (dateformat === "none") {
                thousandsSeparator = "";
                decimalSeparator = "";
            } else {
                const popup = editor.popups.get("fromatDatePlugin.popup");
                const numberInputs = popup.find('input.fr-number[type="text"]');
                const thousandInput = numberInputs.filter('[name="thousands"]');
                const decimalInput = numberInputs.filter('[name="decimal"]');
                thousandsSeparator = thousandInput.val() || "";
                decimalSeparator = decimalInput.val() || "";
            }

            editor.$(el).attr("data-thousands", thousandsSeparator);
            editor.$(el).attr("data-decimal", decimalSeparator);
        }
        editor.$(el).attr("data-format", dateformat);
        if (language === "en-US") {
            language = "en";
        }
        editor.$(el).attr("data-lang", language);
        hidePopup();
        editor.events.trigger("blur", [], true);
        editor.events.focus();
    }

    function choseFormat(newFormat) {
        if (dateformat !== "custom" && newFormat === "custom") {
            thousandsSeparator = ",";
            decimalSeparator = ".";
            const popup = editor.popups.get("fromatDatePlugin.popup");
            const numberInputs = popup.find('input.fr-number[type="text"]');
            const thousandInput = numberInputs.filter('[name="thousands"]');
            const decimalInput = numberInputs.filter('[name="decimal"]');
            thousandInput.val(thousandsSeparator).addClass("fr-not-empty");
            decimalInput.val(decimalSeparator).addClass("fr-not-empty");
            popup.find(".error-field").html("");
            popup.find('button[data-cmd="popupApply"]').removeClass("fr-disabled");
        }
        setInputsVisibility(newFormat);
        dateformat = newFormat;
    }
    function choseLanguage(newLanguage) {
        language = newLanguage;
        hidePopup();
        initPopup();
        setPopupPosition(el);
        editor.popups.show("fromatDatePlugin.popup", coords.left, coords.top, coords.offset);
        setInputsVisibility(dateformat);
    }

    function refreshOnShow($btn, $dropdown) {
        $dropdown.find(".fr-command.fr-active").removeClass("fr-active").attr("aria-selected", false);
        $dropdown.find(`.fr-command[data-param1="${language}"]`).addClass("fr-active").attr("aria-selected", true);
    }

    function refresh($btn) {
        const opts = {
            en: localStorage.getItem("language") === "en" ? "English" : "Engleză",
            ro: localStorage.getItem("language") === "ro" ? "Română" : "Romanian"
        };
        $btn.find("> span").text(opts[language]);
    }

    function getCurrentFormat() {
        return dateformat;
    }

    return {
        getCurrentFormat,
        choseFormat,
        choseLanguage,
        applyFormat,
        showPopup,
        hidePopup,
        refreshOnShow,
        refresh
    };
};

FroalaEditor.DefineIcon("popupCancel", {
    template: "text",
    NAME: i18n.t("generic.cancel")
});
FroalaEditor.RegisterCommand("popupCancel", {
    title: null,
    undo: false,
    focus: false,
    callback() {
        this.fromatDatePlugin.hidePopup();
    }
});

FroalaEditor.DefineIcon("popupApply", {
    template: "text",
    NAME: i18n.t("generic.apply")
});
FroalaEditor.RegisterCommand("popupApply", {
    title: null,
    undo: false,
    focus: false,
    callback() {
        this.fromatDatePlugin.applyFormat();
    }
});

FroalaEditor.RegisterCommand("setFormat", {
    title: null,
    undo: false,
    focus: false,
    callback(cmd, val) {
        this.fromatDatePlugin.choseFormat(val);
    }
});
FroalaEditor.DefineIcon("setLanguage", {
    template: "text",
    NAME: localStorage.getItem("language") === "en" ? "English" : "Română"
});
FroalaEditor.RegisterCommand("setLanguage", {
    type: "dropdown",
    title: null,
    undo: false,
    focus: false,
    html: function html() {
        let c = '<ul class="fr-dropdown-list"  id="language-button" role="presentation">';
        const options = [{ value: "ro", label: localStorage.getItem("language") === "en" ? "Romanian" : "Română" },
            { value: "en", label: localStorage.getItem("language") === "en" ? "English" : "Engleză" }];
        options.forEach(val => {
            c += `<li role="presentation"  class="test">
<a class="fr-command dropdown-options" tabIndex="-1" role="option" data-cmd="setLanguage"
data-param1="${val.value}" title="${val.value}">${val.label}</a></li>`;
        });
        c += "</ul>";
        return c;
    },
    callback(cmd, val) {
        this.fromatDatePlugin.choseLanguage(val);
    },
    refresh: function refresh($btn) {
        this.fromatDatePlugin.refresh($btn);
    },
    refreshOnShow: function refreshOnShow($btn, $dropdown) {
        this.fromatDatePlugin.refreshOnShow($btn, $dropdown);
    },
    plugin: "fromatDatePlugin"
});
